import type { ControlPoint } from "./types";

export interface ControlPointDraft {
  x: number;
  y: number;
  lat: number | null;
  lon: number | null;
}

export function startControlPoint(
  points: ControlPoint[],
  draft: ControlPointDraft | null,
  pixel: { x: number; y: number },
) {
  const committed = commitControlPoint(points, draft);
  return {
    points: committed,
    draft: { x: pixel.x, y: pixel.y, lat: null, lon: null } satisfies ControlPointDraft,
  };
}

export function moveControlPoint(
  draft: ControlPointDraft | null,
  coordinate: { lat: number; lon: number },
): ControlPointDraft | null {
  if (!draft) return null;
  return { ...draft, lat: coordinate.lat, lon: coordinate.lon };
}

export function commitControlPoint(points: ControlPoint[], draft: ControlPointDraft | null): ControlPoint[] {
  if (!draft || draft.lat === null || draft.lon === null) return points;
  return [...points, {
    pixel_x: Math.round(draft.x * 10) / 10,
    pixel_y: Math.round(draft.y * 10) / 10,
    lat: draft.lat,
    lon: draft.lon,
    name: `Kontrollpunkt ${points.length + 1}`,
  }];
}

